<template>
    <div>
        <div v-if="isLoggedIn">
            <button @click="logout">Logout</button>
        </div>
        <div v-else>
            <button @click="login">Login</button>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import * as NAMESPACE_STORE from "../vuexStore/namespaceStore.js";

export default {
    name: "HeadBar",
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters(NAMESPACE_STORE.USER, {
            isLoggedIn: "isLoggedIn"
        })
    },
    methods: {
        ...mapActions(NAMESPACE_STORE.USER, {
            logout: "logout"
        }),
        login() {
            this.$router.push("/login");
        }
    }
}
</script>